module.exports = __webpack_public_path__ + "img/Search.f47573ff.svg";